import { render, staticRenderFns } from "./TemplatedUsername.vue?vue&type=template&id=46fe0e16&"
import script from "./TemplatedUsername.vue?vue&type=script&lang=js&"
export * from "./TemplatedUsername.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports